var map = {
	"./GAME_AIRPLANE.png": "7857",
	"./GAME_BALLOON.png": "e414",
	"./GAME_BEAUTIFULFLOWER.png": "4a69",
	"./GAME_BLOCKFLIP.png": "c30f",
	"./GAME_BUNGEOPPANG.png": "ed24",
	"./GAME_BUTTERFLY.png": "2e5c",
	"./GAME_CARDPAIR.png": "e3c9",
	"./GAME_CARDRIVE.png": "ac75",
	"./GAME_CATCHTHEFISH.png": "c2ae",
	"./GAME_CATCHTHEMOLE.png": "8883",
	"./GAME_COLORDRAW.png": "309c",
	"./GAME_COLORLOTUS.png": "35ce",
	"./GAME_COLORPAPER.png": "209c",
	"./GAME_COUNTCHICKS.png": "8ab8",
	"./GAME_CROSSTURTLE.png": "ea4b",
	"./GAME_FINDSAMEPICTURE.png": "db6f",
	"./GAME_FLAG.png": "87c5",
	"./GAME_GETTHENUMBERDISH.png": "1fb8",
	"./GAME_GLACIER.png": "19e6",
	"./GAME_GOSTOP.png": "d064",
	"./GAME_GUKHWAPPANG.png": "0107",
	"./GAME_HORSE.png": "a4fd",
	"./GAME_LIGHTBUG.png": "12c1",
	"./GAME_MINHWATU.png": "59e0",
	"./GAME_NIGHTSKY.png": "98ad",
	"./GAME_NUMBER.png": "3cde",
	"./GAME_OILPAINT.png": "2dc6",
	"./GAME_OXQUIZ.png": "5fe9",
	"./GAME_PAINTBALL.png": "4029",
	"./GAME_PIANO.png": "3453b",
	"./GAME_PICTURELOTUS.png": "c6b5",
	"./GAME_POND.png": "e9da",
	"./GAME_QUIZ.png": "89d8",
	"./GAME_RAINWINDOW.png": "5f3f",
	"./GAME_SEAOFFANTASY.png": "2965",
	"./GAME_SEAWORLD.png": "4d85",
	"./GAME_SOCCER.png": "738b",
	"./GAME_SOUNDLINK.png": "f55f",
	"./GAME_SWEEPLEAVES.png": "ab35",
	"./GAME_THREE.png": "8fac",
	"./GAME_TRAIN.png": "a21d",
	"./GAME_WORDFERRISWHEEL.png": "b8066",
	"./RECREATION_MATCHPICTURE.png": "4847",
	"./RECREATION_SAMEACTION.png": "1e6f",
	"./RECREATION_SPEEDQUIZ.png": "57e7",
	"./RECREATION_YOURFEELING.png": "1987",
	"./SURVEY_ANXIETYSCALE.png": "1a7b",
	"./SURVEY_ANXIETYSCALE_SM.png": "d707",
	"./SURVEY_DEPRESSIONSCALE.png": "c24e",
	"./SURVEY_DEPRESSIONSCALE_SM.png": "10da",
	"./SURVEY_HAPPINESS.png": "f8b3",
	"./SURVEY_HAPPINESS_SM.png": "cddb",
	"./SURVEY_MEMORYLOSS.png": "7c68",
	"./SURVEY_MEMORYLOSS_SM.png": "2367",
	"./SURVEY_MMSE.png": "fd5f",
	"./SURVEY_MMSE_SM.png": "7d91",
	"./아이콘_배고픈-판다_ver.png": "ef94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f811";